import { ContentPreviewData } from '../types';

/**
 * Handles external link opening with support for custom share handlers
 */
export const handleExternalLink = (content: ContentPreviewData | null, showErrorMessage: (message: string) => void) => {
  if (!content) {
    showErrorMessage('No content available');
    return;
  }

  if (content.onShare) {
    content.onShare();
  } else {
    const url = content.originalUrl;
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      showErrorMessage('No external URL available for this post');
    }
  }
};

/**
 * Handles download with support for custom download handlers
 */
export const handleDownload = (
  content: ContentPreviewData | null,
  fallbackHandler: () => void
) => {
  if (!content) {
    // If no content is available, we can't proceed with download
    // The fallback handler might have its own error handling
    fallbackHandler();
    return;
  }

  if (content.onDownload) {
    content.onDownload();
  } else {
    fallbackHandler();
  }
};
